//if you load more results on mobile view, hide paging and require loading results with ajax
//from here on out
$('#product-listing-container-ajax').on('bq.ajaxContent.loadEnd', function() {
  var container = $('#product-listing-container-ajax');
  $('.pagination-load-more', container).removeClass('hidden-md hidden-lg');
  $('.pagination', container).hide();
});


//setting up filters open by default
if (!bq.marketplace) { bq.marketplace = {}; }

bq.marketplace.searchFilters = function() {
  var $trigger = $('#page-filter-list');

  $trigger.on('show.bs.collapse', function(e) {
    var $el = $(e.target);

    if(!$el.is($trigger)) { return; }

    if($el.data('openDefault')) {
      var toOpen = $el.data('openDefault');

      //lets close them all
      $('.filter-header', $el).addClass('collapsed');
      //$('.filter-sub-group', $el).collapse('hide');
      $('.filter-sub-group', $el).removeClass('in');

      if(Modernizr.mq('only screen and (max-width: 767px)')) { //if its mobile, open in order
        $('.filter-group', $el).each(function(index) {

          if(index >= toOpen) { return false; }
          var $parent = $(this);

          $('.filter-header', $parent).removeClass('collapsed');
          $('.filter-sub-group', $parent).collapse('show');


        });
      } else { //otherwise, open first 2 for each top column
        var $cols = 2;
        var open = 1;

        if(Modernizr.mq('only screen and (min-width: 1024px)')) { //if its desktop, change to 3 columns
          $cols = 3;
        }

        if($el.data('cols')) {
            $cols = $el.data('cols');
        }

        open = Math.round(toOpen / $cols);

        $('> .row > div', $el).each(function(i) {
          if(i == $cols) { return false; }
          var $row = $(this);
          $('.filter-group', $row).each(function(index) {
            if(index == open) { return false; }
            var $parent = $(this);
            $('.filter-header', $parent).removeClass('collapsed');
            $('.filter-sub-group', $parent).collapse('show');
          });
        });

      }

    }
  });

  $('[data-update-price]').on('click', function(e){
    var url = $('#solrbridge-price-url').val(),
        to  = parseFloat($('#solrbridge-price-to').val()),
        from = parseFloat($('#solrbridge-price-from').val()),
        newFrom = (typeof from ==='number') ? from : $('#solrbridge-price-min').val(),
        newTo = (typeof to ==='number') ? to : $('#solrbridge-price-max').val();
        //build url
        var finalUrl = url.replace('NEWPRICEFILTER', newFrom+'+TO+'+newTo);
        window.location = finalUrl;

  });



};


bq.init.push(bq.marketplace.searchFilters);
